
import CoreAPIService from '@/modules/core/services/apiService'

import LoginView  from '@/modules/core/views/login.vue'
import MobileLoginView  from '@/modules/core/views/mobileLogin.vue'

export default class CoreModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.coreService = new CoreAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi) 
  }
  
  getRoutes() {
    return [
      // Public
      {
        path: '/login',
        name: 'Login',
        // Note: For some reason Vue-router doesn't set meta fields correctly on lazy-loaded components
        // So to stop the 'layout' flicker on 1st load, we don't lazy load the Login View
        component: LoginView,
        meta: {
          title: 'Login',
          layout: 'Blank'
        }
      },
      {
        path: '/account/registration',
        name: 'AccountRegistration',
        component: () => import('@/modules/core/views/accountRegistration.vue'),
        meta: {
          title: 'Account Registration',
          layout: 'Blank'
        }
      },
      {
        path: '/account/registration/complete',
        name: 'AccountRegistrationComplete',
        component: () => import('@/modules/core/views/accountRegistrationComplete.vue'),
        meta: {
          title: 'Complete Account Registration',
          layout: 'Blank'
        }
      },
      {
        path: '/account/forgotpassword',
        name: 'AccountForgotPassword',
        component: () => import('@/modules/core/views/accountForgotPassword.vue'),
        meta: {
          title: 'Forgot Password',
          layout: 'Blank'
        }
      },
      {
        path: '/account/resetpassword',
        name: 'AccountResetForgottenPassword',
        component: () => import('@/modules/core/views/accountResetForgottenPassword.vue'),
        meta: {
          title: 'Reset Password',
          layout: 'Blank'
        }
      },
      {
        path: '/account/invitation/:code',
        name: 'AccountRegistrationInvite',
        component: () => import('@/modules/core/views/accountRegistrationInvite.vue'),
        meta: {
          noRedirectForAuth: true,
          title: 'Account Registration',
          layout: 'Blank'
        }
      },
      {
        path: '/about/terms',
        name: 'TermsOfUse',
        component: () => import('@/modules/core/views/legalTermsOfUse.vue'),
        meta: {
          noRedirectForAuth: true,
          title: 'Terms of use',
          layout: 'Legal'
        }
      },
      {
        path: '/about/privacy',
        name: 'PrivacyPolicy',
        component: () => import('@/modules/core/views/legalPrivacyPolicy.vue'),
        meta: {
          noRedirectForAuth: true,
          title: 'Privacy Policy',
          layout: 'Legal'
        }
      },
      {
        path: '/about/support/app',
        name: 'SupportPage',
        component: () => import('@/modules/core/views/supportApp.vue'),
        meta: {
          noRedirectForAuth: true,
          title: 'App - Support',
          layout: 'Legal'
        }
      },

      // Private
      {
        path: '/',
        name: 'Dashboard',
        component: () => import('@/modules/core/views/dashboard.vue'),
        meta: {
          requiresAuth: true,
          hideBreadcrumbs: true,
          title: 'Dashboard',
          menuLink: '/'
        }
      }
    ]
  }
}